import { Form, Select } from 'antd'
import * as React from 'react'
import { FC } from 'react'

const status = [
    {
        value: 'Создан',
        label: 'Создан',
    },
    {
        value: 'Прибыл',
        label: 'Прибыл',
    },
    {
        value: 'В приемке',
        label: 'В приемке',
    },
    {
        value: 'Завершен',
        label: 'Завершен',
    },
]

interface StatusProps {
    onChange?: () => void
}

const Status: FC<StatusProps> = ({ onChange }) => {
    return (
        <Form.Item name={'receiptStatus'} label={'Статус'}>
            <Select disabled options={status} style={{ width: '100%' }} onChange={onChange} />
        </Form.Item>
    )
}

export default Status
